"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.line = void 0;
exports.line = {
    height: {
        default: '100%',
        xs: '115%',
        sm: '120%',
        md: '133%',
        lg: '150%',
        xl: '170%',
        xxl: '200%'
    }
};
